import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FolderBreadcrumbs } from '@core/util/folder';
import { Folder } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BusinessFoldersState } from '@state/business/folders/folders.state';

export interface TemplateFolderDeleteDialogData {
	folder: Folder;
}
export type TemplateFolderDeleteDialogClose = Folder;

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-delete-folder-dialog',
	templateUrl: 'template-folder-delete-dialog.component.html',
	standalone: false,
})
export class TemplateFolderDeleteDialogComponent implements OnInit {
	breadcrumbs: Folder[];
	@SelectSnapshot(BusinessFoldersState.getAll) folders: Folder[];

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: TemplateFolderDeleteDialogData,
		private dialogRef: MatDialogRef<TemplateFolderDeleteDialogComponent>,
	) {}

	ngOnInit(): void {
		this.breadcrumbs = FolderBreadcrumbs(this.data.folder.id, this.folders).map(
			(folderId) => this.folders.find((folder) => folder.id === folderId),
		);
	}

	cancelModal(): void {
		this.dialogRef.close();
	}

	deleteFolder(): void {
		const data: TemplateFolderDeleteDialogClose = this.data.folder;
		this.dialogRef.close(data);
	}
}
